module.exports = __webpack_public_path__ + "static/img/logo@2x_1.2e2cc6c8.png";